import "./Contact.module.css";
import CorporateCoffeeCapsulesAndMachines from "@/reusable_sections/Header";
import ParlonsDeVotreProjet from "./sections/ParlonsDeVotreProjet";
import DakarThiesExpress from "./sections/DakarThiesExpress";
export default function ContactPage() {
  return <div>
      <CorporateCoffeeCapsulesAndMachines />
      <ParlonsDeVotreProjet />
      <DakarThiesExpress />
    </div>;
}